import { useNavigate } from 'react-router-dom';
import DetailsSidebar from '@/components/DetailsSidebar';
import { useStudy } from '@/hooks/studies/useStudy';
import StudyDetailsContent from './StudyDetailsContent';
import StudyDocuments from './StudyDocuments';

const StudyDrawer = ({
  studyId,
  isOpen,
  onClose,
}: {
  studyId: string | null;
  isOpen: boolean;
  onClose: () => void;
}) => {
  const navigate = useNavigate();
  const { data: study } = useStudy(studyId ?? '');

  if (!studyId) return null;

  const displayId = study?.display_id || studyId.slice(0, 8).toUpperCase();

  const tabs = [
    {
      id: 'details',
      label: 'Details',
      content: <StudyDetailsContent studyId={studyId} />,
    },
    {
      id: 'documents',
      label: 'Submitted Documents',
      content: <StudyDocuments studyId={studyId} compact />,
    },
  ];

  return (
    <DetailsSidebar
      open={isOpen}
      onOpenChange={open => {
        if (!open) onClose();
      }}
      displayId={displayId}
      tabs={tabs}
      defaultTab="details"
      footerLabel="View Study"
      onFooterClick={() => {
        onClose();
        navigate(`/studies/${studyId}`);
      }}
    />
  );
};

export default StudyDrawer;
